"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineObject5ToJSON = exports.InlineObject5FromJSONTyped = exports.InlineObject5FromJSON = void 0;
function InlineObject5FromJSON(json) {
    return InlineObject5FromJSONTyped(json, false);
}
exports.InlineObject5FromJSON = InlineObject5FromJSON;
function InlineObject5FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': json['userId'],
        'reason': json['reason'],
    };
}
exports.InlineObject5FromJSONTyped = InlineObject5FromJSONTyped;
function InlineObject5ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'reason': value.reason,
    };
}
exports.InlineObject5ToJSON = InlineObject5ToJSON;
